import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfobluIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#1da193",
	width: 61.721,
	height: 61.721,
	viewBox: "0 0 61.721 61.721",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "info_FILL1_wght400_GRAD0_opsz48",
		d: "M35.092,50.291a2.243,2.243,0,0,0,2.315-2.315V34.012a2.1,2.1,0,0,0-.694-1.582,2.285,2.285,0,0,0-1.62-.656,2.243,2.243,0,0,0-2.315,2.315V48.053a2.1,2.1,0,0,0,.694,1.582A2.285,2.285,0,0,0,35.092,50.291ZM34.86,26.065a2.535,2.535,0,0,0,1.813-.694,2.337,2.337,0,0,0,.733-1.774,2.593,2.593,0,0,0-.733-1.852,2.516,2.516,0,0,0-3.626,0,2.593,2.593,0,0,0-.733,1.852,2.337,2.337,0,0,0,.733,1.774,2.535,2.535,0,0,0,1.813.694Zm0,39.656a31.3,31.3,0,0,1-12.19-2.353A29.869,29.869,0,0,1,6.353,47.05,31.3,31.3,0,0,1,4,34.86,31.1,31.1,0,0,1,6.353,22.748a30.119,30.119,0,0,1,6.519-9.8A30.767,30.767,0,0,1,34.86,4a30.613,30.613,0,0,1,30.86,30.86,30.767,30.767,0,0,1-8.95,21.988,30.119,30.119,0,0,1-9.8,6.519A31.1,31.1,0,0,1,34.86,65.721Z",
		transform: "translate(-4 -4)"
	})
});
export { SvgInfobluIcon as ReactComponent };
